/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Card, Row, Col } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { roleService } from '../../../services/userService';
import Breadcrumb from '../../../components/ui/Breadcrumb';
const AddRole = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(isEditMode);

  useEffect(() => {
    const fetchData = async () => {
      if (isEditMode && id) {
        try {
          const role = await roleService.getById(parseInt(id));
          form.setFieldsValue({
            name: role.name,
            description: role.description,
          });
        } catch (error) {
          console.error('Error fetching role:', error);
          message.error('Error al cargar datos del rol');
        } finally {
          setInitialLoading(false);
        }
      } else {
        setInitialLoading(false);
      }
    };

    fetchData();
  }, [id, isEditMode, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEditMode) {
        await roleService.update(parseInt(id), values);
        message.success('Rol actualizado correctamente');
      } else {
        await roleService.create(values);
        message.success('Rol creado correctamente');
      }
      navigate('/roles');
    } catch (error) {
      console.error('Error saving role:', error);
      message.error(`Error al ${isEditMode ? 'actualizar' : 'crear'} rol`);
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return (
      <div className="text-center">Cargando...</div>
    );
  }

  return (
    <>
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">{isEditMode ? 'Editar' : 'Nuevo'} Rol</h3>
                <Breadcrumb items={[{ label: 'Inicio', to: '/admin-dashboard' }, { label: 'Roles', to: '/roles' }, { label: isEditMode ? 'Editar' : 'Nuevo' }]} />
              </div>
            </div>
          </div>

          <Row justify="center">
            <Col xs={24} lg={12}>
              <Card title={isEditMode ? 'Editar Rol' : 'Nuevo Rol'}>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                >
                  <Form.Item
                    label="Nombre"
                    name="name"
                    rules={[
                      { required: true, message: 'Por favor ingrese el nombre del rol' },
                      { max: 155, message: 'El nombre no puede exceder 155 caracteres' },
                    ]}
                  >
                    <Input placeholder="Ingrese el nombre del rol" />
                  </Form.Item>

                  <Form.Item
                    label="Descripción"
                    name="description"
                    rules={[
                      { required: true, message: 'Por favor ingrese la descripción' },
                      { max: 255, message: 'La descripción no puede exceder 255 caracteres' },
                    ]}
                  >
                    <Input.TextArea placeholder="Descripción del rol" rows={4} />
                  </Form.Item>

                  <Row justify="end" gutter={8}>
                    <Col>
                      <Button type="default" onClick={() => navigate('/roles')}>
                        Cancelar
                      </Button>
                    </Col>
                    <Col>
                      <Button type="primary" htmlType="submit" loading={loading}>
                        {isEditMode ? 'Actualizar' : 'Crear'} Rol
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </Col>
          </Row>
    </>
  );
};

export default AddRole;
